import { render, staticRenderFns } from "./FormDocument.vue?vue&type=template&id=49584f50&scoped=true"
import script from "./FormDocument.vue?vue&type=script&lang=js"
export * from "./FormDocument.vue?vue&type=script&lang=js"
import style0 from "./FormDocument.vue?vue&type=style&index=0&id=49584f50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49584f50",
  null
  
)

export default component.exports